import { combineReducers } from 'redux';
import analyticsAppReducer from './analytics-app-reducer';
import apiStatus from './api-status-reducer';


const rootReducer = combineReducers({
    analytics: analyticsAppReducer,
    apiStatus
});

export default rootReducer;
